import { ApiError } from 'upstream-shared/models';
import {
  API_REQUEST_NOT_AUTHORIZED,
  GET_DOWNLOAD_TOKEN,
  NEW_ACCESS_TOKEN_RECEIVED,
  UPDATE_DATA_PROCESSING_QUEUE,
  UPDATE_LOAD_STATUS,
  UPDATE_MAINTENANCE_WINDOW,
} from '../actions/actionTypes';
import { accessToken } from '../utils/Tokens';
import { asyncAction } from '../actions/asyncAction';
import { AppState } from '../reducers';
import { upstreamApi } from './index';

export const newAccessTokenReceived = (token: string) => {
  accessToken.set(token);
  return { type: NEW_ACCESS_TOKEN_RECEIVED, payload: { token } };
};

export const apiRequestNotAuthorized = (apiError: ApiError, forceLogout: boolean = true, requestedFreeDoc: boolean = false) => {
  if (forceLogout) {
    accessToken.delete();
  }
  return {
    type: API_REQUEST_NOT_AUTHORIZED,
    error: true,
    payload: { error: apiError, requestedFreeDoc },
  };
};

export const updateMaintenanceWindow = (date?: Date) => {
  return { type: UPDATE_MAINTENANCE_WINDOW, payload: date };
};

export type DataProcessingQueueEntry = {
  status: 'processed' | 'processing' | 'retrieve_failed' | 'retrieved' | 'staging' | 'failed_staging';
  status_count: number;
  earliest_created_on: string;
  latest_updated_on: string | null;
};

export const updateDataProcessingQueue = (dataProcessingQueue: DataProcessingQueueEntry[]) => {
  return { type: UPDATE_DATA_PROCESSING_QUEUE, payload: dataProcessingQueue };
};

export const updateLoadStatus = (payload: { loadStartedAt: Date | null; loadUpdatedAt: Date | null; loadStatus?: string | null }) => {
  return { type: UPDATE_LOAD_STATUS, payload };
};

export function getDownloadToken(baseUrl: string, id: string) {
  return asyncAction<AppState>({
    actionType: GET_DOWNLOAD_TOKEN,
    func: async () => (await upstreamApi.adminObjects.getDownloadToken(baseUrl, id)).data,
  });
}
